define(["require", "exports", "tslib", "@material-ui/core/Checkbox", "@material-ui/core/Table", "@material-ui/core/TableBody", "@material-ui/core/TableCell", "@material-ui/core/TableContainer", "@material-ui/core/TableHead", "@material-ui/core/TablePagination", "@material-ui/core/TableRow", "@material-ui/core/TableSortLabel", "@material-ui/core/TextField", "@material-ui/core/styles", "mobx-react", "moment", "react", "react-table", "../../../model", "../../../utils/Currency", "../../../utils/EntityUtil", "../DomainField", "../VGroup", "./TablePaginationActions"], function (require, exports, tslib_1, Checkbox_1, Table_1, TableBody_1, TableCell_1, TableContainer_1, TableHead_1, TablePagination_1, TableRow_1, TableSortLabel_1, TextField_1, styles_1, mobx_react_1, moment_1, React, react_table_1, model_1, Currency_1, EntityUtil_1, DomainField_1, VGroup_1, TablePaginationActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DataList = exports.DomainCellEditable = exports.DomainCell = exports.DeleteCheckboxCell = exports.CheckboxCell = exports.DateTimeCell = exports.DateCell = exports.LinkCell = exports.NumberCellEditable = exports.TextCellEditable = exports.CurrencyCell = exports.TextCell = exports.DataTable = void 0;
    Checkbox_1 = tslib_1.__importDefault(Checkbox_1);
    Table_1 = tslib_1.__importDefault(Table_1);
    TableBody_1 = tslib_1.__importDefault(TableBody_1);
    TableCell_1 = tslib_1.__importDefault(TableCell_1);
    TableContainer_1 = tslib_1.__importDefault(TableContainer_1);
    TableHead_1 = tslib_1.__importDefault(TableHead_1);
    TablePagination_1 = tslib_1.__importDefault(TablePagination_1);
    TableRow_1 = tslib_1.__importDefault(TableRow_1);
    TableSortLabel_1 = tslib_1.__importDefault(TableSortLabel_1);
    TextField_1 = tslib_1.__importDefault(TextField_1);
    moment_1 = tslib_1.__importDefault(moment_1);
    React = tslib_1.__importStar(React);
    TablePaginationActions_1 = tslib_1.__importDefault(TablePaginationActions_1);
    const useStyles = (0, styles_1.makeStyles)(theme => ({
        root: {
            marginBottom: '10px',
            overflow: "auto",
            cursor: 'pointer'
        },
        resizer: {
            width: "6px",
            height: "100%",
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 1,
            touchAction: "none",
            transition: 'background-color 0.5s ease',
            "&.isResizing": {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
        },
        table: {
            border: '1px solid rgba(200, 200, 200, 0.2)'
        },
        headerRow: {
            backgroundColor: '#f6f7f8',
            backgroundImage: 'linear-gradient(#fff, #efefef)',
        },
        row: {
            transition: 'background-color 0.5s ease',
            "&:hover": {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
        },
        even: {
            backgroundColor: '#fff'
        },
        odd: {
            backgroundColor: 'rgba(0, 0, 0, 0.01)'
        },
        selected: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            "&:hover": {
                backgroundColor: 'rgba(0, 0, 0, 0.15)'
            }
        }
    }));
    const DEFAULT_PAGE_SIZE = 10;
    exports.DataTable = (0, mobx_react_1.observer)(props => {
        var _a, _b, _c;
        const { update, canSelect, canPage, onRowClick, onRowDoubleClick, selectedId } = props;
        const [data, setData] = React.useState([...props.data || []]);
        const classes = useStyles();
        let dataLastPatch;
        React.useEffect(() => {
            if (props.data) {
                if (props.data !== data && props.data !== dataLastPatch) {
                    console.info("Table data update. Reference");
                    dataLastPatch = props.data;
                    setData([...props.data]);
                }
                else if (props.data.length != data.length) {
                    console.info("Table data update. Row count change", props.data.length, data.length);
                    setData([...props.data]);
                }
            }
        }, [(_a = props.data) === null || _a === void 0 ? void 0 : _a.length, props.data]);
        const columns = React.useMemo(() => props.columns, []);
        const defaultColumn = React.useMemo(() => ({
            minWidth: 30,
            width: 150,
            maxWidth: 200,
        }), []);
        const enablePaging = (canPage == undefined || !!canPage) && data.length > ((_b = props.pageSize) !== null && _b !== void 0 ? _b : DEFAULT_PAGE_SIZE);
        const enableSelection = canSelect;
        const plugins = [
            react_table_1.useSortBy,
            react_table_1.usePagination,
            react_table_1.useResizeColumns,
            react_table_1.useFlexLayout,
            react_table_1.useRowSelect,
        ].filter(x => !!x);
        const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page, canPreviousPage, canNextPage, pageCount, gotoPage, setPageSize, state: { pageIndex, pageSize, selectedRowIds }, } = (0, react_table_1.useTable)({
            columns,
            data,
            defaultColumn,
            disableSortRemove: true,
            disableResizing: false,
            update,
            initialState: {
                pageSize: (_c = props.pageSize) !== null && _c !== void 0 ? _c : DEFAULT_PAGE_SIZE
            },
        }, ...plugins, hooks => {
            if (enableSelection) {
                hooks.allColumns.push(columns => [
                    {
                        id: 'selection',
                        disableResizing: true,
                        minWidth: 40,
                        width: 40,
                        maxWidth: 40,
                        Header: ({ getToggleAllRowsSelectedProps }) => React.createElement("div", null,
                            React.createElement(IndeterminateCheckbox, Object.assign({}, getToggleAllRowsSelectedProps()))),
                        Cell: ({ row }) => React.createElement("div", null,
                            React.createElement(IndeterminateCheckbox, Object.assign({}, row.getToggleRowSelectedProps())))
                    },
                    ...columns,
                ]);
                hooks.useInstanceBeforeDimensions.push(({ headerGroups }) => {
                    const selectionGroupHeader = headerGroups[0].headers[0];
                    selectionGroupHeader.canResize = false;
                });
            }
        });
        const handleChangePage = (e, pageIndex) => {
            gotoPage(pageIndex);
        };
        const handleChangeRowsPerPage = e => {
            setPageSize(Number(e.target.value));
        };
        const handleRowClick = (row) => {
            onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(row.original);
        };
        const handleRowDoubleClick = (row) => {
            onRowDoubleClick === null || onRowDoubleClick === void 0 ? void 0 : onRowDoubleClick(row.original);
        };
        const isSelected = (row) => {
            var _a;
            return selectedId && ((_a = row === null || row === void 0 ? void 0 : row.original) === null || _a === void 0 ? void 0 : _a.Id) == selectedId;
        };
        return React.createElement("div", { className: classes.root },
            React.createElement(TableContainer_1.default, null,
                React.createElement(Table_1.default, Object.assign({}, getTableProps(), { className: classes.table }),
                    React.createElement(TableHead_1.default, null, headerGroups.map(headerGroup => (React.createElement(TableRow_1.default, Object.assign({}, headerGroup.getHeaderGroupProps(), { className: classes.headerRow }), headerGroup.headers.map(column => (React.createElement(TableCell_1.default, Object.assign({}, (column.id === 'selection'
                        ? column.getHeaderProps()
                        : column.getHeaderProps(column.getSortByToggleProps()))),
                        column.render('Header'),
                        column.id !== 'selection' ? (React.createElement(TableSortLabel_1.default, { active: column.isSorted, direction: column.isSortedDesc ? 'desc' : 'asc', hideSortIcon: true })) : null,
                        column.direction,
                        column.canResize && (React.createElement("div", Object.assign({}, column.getResizerProps(), { className: `${classes.resizer} ${column.isResizing ? 'isResizing' : ''}` })))))))))),
                    React.createElement(TableBody_1.default, Object.assign({}, getTableBodyProps()), page.map((row, i) => {
                        prepareRow(row);
                        return React.createElement(TableRow_1.default, Object.assign({}, row.getRowProps(), { className: `${classes.row} ${i % 2 == 0 ? classes.even : classes.odd} ${isSelected(row) ? classes.selected : ""}`, onClick: () => handleRowClick(row), onDoubleClick: () => handleRowDoubleClick(row) }), row.cells.map(cell => {
                            return React.createElement(TableCell_1.default, Object.assign({}, cell.getCellProps()), cell.render('Cell'));
                        }));
                    })))),
            enablePaging
                ? React.createElement(TablePagination_1.default, { rowsPerPageOptions: [
                        ...(props.pageSize ? [props.pageSize] : [10, 25, 50]),
                        { label: 'All', value: data.length },
                    ], count: data.length, rowsPerPage: pageSize, page: pageIndex, SelectProps: {
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                    }, onPageChange: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage, ActionsComponent: TablePaginationActions_1.default })
                : null);
    });
    const IndeterminateCheckbox = React.forwardRef((_a, ref) => {
        var { indeterminate } = _a, rest = tslib_1.__rest(_a, ["indeterminate"]);
        const defaultRef = React.useRef();
        const resolvedRef = (ref || defaultRef);
        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);
        return React.createElement(React.Fragment, null,
            React.createElement(Checkbox_1.default, Object.assign({ ref: resolvedRef }, rest)));
    });
    ;
    function toUpdateArgs(props) {
        const { row, column } = props;
        return { item: row.original, rowIndex: row.index, column };
    }
    function parseCellProps(props) {
        var _a, _b;
        const initialValue = (_a = props.row.original[props.column.toString()]) !== null && _a !== void 0 ? _a : null;
        const error = (_b = props.row.original[props.column.toString() + "Error"]) !== null && _b !== void 0 ? _b : null;
        const raw = props.row.original;
        return { initialValue, error, raw };
    }
    function renderCell(value, error, editable) {
        return React.createElement(VGroup_1.VGroup, { className: editable ? "row-editable" : "" },
            value,
            error ? React.createElement("div", { className: "field-error-label" }, error) : null);
    }
    exports.TextCell = (0, mobx_react_1.observer)(props => {
        const { initialValue, error } = parseCellProps(props);
        const [value, setValue] = React.useState(initialValue);
        React.useEffect(() => {
            setValue(initialValue);
        }, [initialValue]);
        return renderCell(React.createElement("div", null, props.transform ? props.transform(value) : value), error);
    });
    exports.CurrencyCell = (0, mobx_react_1.observer)(props => {
        const { initialValue, error } = parseCellProps(props);
        const [value, setValue] = React.useState(initialValue);
        React.useEffect(() => {
            setValue(initialValue);
        }, [initialValue]);
        const renderer = React.createElement("div", { style: { display: "flex", justifyContent: "flex-end" } }, (0, Currency_1.currency)(value));
        return renderCell(renderer, error);
    });
    exports.TextCellEditable = (0, mobx_react_1.observer)(props => {
        const { update, disabled, multiline } = props;
        const { initialValue, error } = parseCellProps(props);
        const [value, setValue] = React.useState(initialValue);
        const onChange = e => {
            setValue(e.target.value);
        };
        const onBlur = () => {
            update(Object.assign(Object.assign({}, toUpdateArgs(props)), { value }));
        };
        React.useEffect(() => {
            setValue(initialValue);
        }, [initialValue]);
        const opts = {};
        if (multiline) {
            opts.multiline = true;
            opts.rows = 5;
        }
        const renderer = React.createElement(TextField_1.default, Object.assign({}, opts, { value: value, onChange: onChange, onBlur: onBlur, disabled: disabled }));
        return renderCell(renderer, error, !disabled);
    });
    function pcToValue(fraction, precision) {
        const pc = fraction * 100;
        if (precision > 0 && (pc % 1) > 0) {
            return Math.trunc(pc) + parseFloat((pc % 1).toFixed(precision));
        }
        return pc;
    }
    exports.NumberCellEditable = (0, mobx_react_1.observer)(props => {
        const { disabled, update } = props;
        let { initialValue, error, raw } = parseCellProps(props);
        if (raw === undefined) {
            return null;
        }
        const precision = props.precision ? props.precision : (!!props.isPc ? 2 : 0);
        const initialValue2 = props.isPc
            ? pcToValue(initialValue, precision)
            : initialValue;
        const [error2, setError2] = React.useState(error);
        const [value, setValue] = React.useState(initialValue2);
        const onChange = e => {
            if (/[^\d\-\.]/.test(e.target.value)) {
                return;
            }
            let newValue = e.target.value || 0;
            let newValRaw = parseFloat(newValue);
            if (props.isPc) {
                newValRaw = newValRaw / 100;
            }
            setValue(newValue);
            update(Object.assign(Object.assign({}, toUpdateArgs(props)), { value: props.isString ? newValRaw.toString() : newValRaw }));
            if (error) {
                setError2(error);
            }
            else {
                setError2("");
            }
        };
        React.useEffect(() => {
            setValue(initialValue2);
        }, [initialValue2]);
        React.useEffect(() => {
            setError2(error);
        }, [error]);
        const renderer = React.createElement(TextField_1.default, { value: value, onChange: onChange, disabled: disabled });
        return renderCell(renderer, error2, !disabled);
    });
    exports.LinkCell = (0, mobx_react_1.observer)(props => {
        const { initialValue: value, error, raw } = parseCellProps(props);
        const handleClick = () => {
            var _a;
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, raw);
        };
        const renderer = value
            ? React.createElement("a", { className: "linkCell", onClick: handleClick }, value)
            : null;
        return renderCell(renderer, error);
    });
    exports.DateCell = (0, mobx_react_1.observer)(props => {
        const { initialValue: value, error } = parseCellProps(props);
        const renderer = React.createElement("div", null, value
            ? (0, moment_1.default)(value).format(props.format || "DD/MM/YYYY")
            : null);
        return renderCell(renderer, error);
    });
    exports.DateTimeCell = (0, mobx_react_1.observer)(props => {
        const { initialValue: value, error } = parseCellProps(props);
        const renderer = React.createElement("div", null, value
            ? (0, moment_1.default)(value).format(props.format || "DD/MM/YYYY HH:mm")
            : null);
        return renderCell(renderer, error);
    });
    exports.CheckboxCell = (0, mobx_react_1.observer)(props => {
        const toBoolean = (x) => {
            return typeof x == "number" ? x === 1 : x;
        };
        const { update, disabled, isInteger } = props;
        const { initialValue, error } = parseCellProps(props);
        const [value, setValue] = React.useState(toBoolean(initialValue));
        const onChange = (e) => {
            setValue(e.target.checked);
            update(Object.assign(Object.assign({}, toUpdateArgs(props)), { value: isInteger ? (e.target.checked ? 1 : 0) : e.target.checked }));
        };
        React.useEffect(() => {
            setValue(toBoolean(initialValue));
        }, [initialValue]);
        const renderer = React.createElement(Checkbox_1.default, { style: { padding: "0px" }, checked: value, disabled: disabled, onChange: onChange });
        return renderCell(renderer, error);
    });
    exports.DeleteCheckboxCell = (0, mobx_react_1.observer)(props => {
        const { disabled } = props;
        const { initialValue, error, raw } = parseCellProps(props);
        const [value, setValue] = React.useState(initialValue == model_1.PersistanceStates.MARKED_FOR_DELETION);
        const onChange = (e) => {
            var _a;
            const prev = raw.PersistanceState;
            if (e.target.checked) {
                raw.markForDeletion();
            }
            else {
                raw.undoDeletion();
            }
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, raw, prev, raw.PersistanceState);
        };
        React.useEffect(() => {
            setValue(initialValue == model_1.PersistanceStates.MARKED_FOR_DELETION);
        }, [initialValue]);
        const renderer = React.createElement(Checkbox_1.default, { style: { padding: "0px" }, checked: value, disabled: disabled || raw.PersistanceState === model_1.PersistanceStates.NEW_RECORD, onChange: onChange });
        return renderCell(renderer, error);
    });
    exports.DomainCell = (0, mobx_react_1.observer)(props => {
        const { domain, format } = props;
        const { initialValue, error, raw } = parseCellProps(props);
        const [value, setValue] = React.useState(initialValue);
        const [displayValue, setDisplayValue] = React.useState(initialValue);
        React.useEffect(() => {
            var _a, _b, _c, _d;
            if (typeof domain === "string") {
                if (!raw[domain]) {
                    throw new Error(`Invalid or undefined Domain type provided ${domain}`);
                }
            }
            let k = initialValue;
            let v = typeof domain === "string"
                ? (_c = (_b = (_a = raw[domain]) === null || _a === void 0 ? void 0 : _a.findByKey) === null || _b === void 0 ? void 0 : _b.call(_a, k)) === null || _c === void 0 ? void 0 : _c.value
                : (_d = domain === null || domain === void 0 ? void 0 : domain.findByKey(k)) === null || _d === void 0 ? void 0 : _d.value;
            if (!!format && raw[format]) {
                v = raw[format].replace("{0}", v);
            }
            setValue(initialValue);
            setDisplayValue(v);
        }, [initialValue]);
        const renderer = React.createElement("div", null, displayValue);
        return renderCell(renderer, error);
    });
    exports.DomainCellEditable = (0, mobx_react_1.observer)(props => {
        const { domain, disabled, update } = props;
        const { initialValue, error, raw } = parseCellProps(props);
        const [value, setValue] = React.useState(initialValue);
        React.useEffect(() => {
            setValue(initialValue);
        }, [initialValue]);
        if (!disabled) {
            const onChange = (e) => {
                setValue(e.target.value);
                update(Object.assign(Object.assign({}, toUpdateArgs(props)), { value: e.target.value }));
            };
            const style = {
                fontSize: "inherit",
                lineHeight: "24px",
                height: "24px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "pre"
            };
            if (typeof domain === "string") {
                if (!raw[domain]) {
                    throw new Error(`Invalid or undefined Domain type provided ${domain}`);
                }
            }
            const values = typeof domain === "string" ? raw[domain].Values : domain.Values;
            const field = (0, DomainField_1.makeDomainField)(Object.assign(Object.assign({}, props), { id: (0, EntityUtil_1.id)().toString(), style, domainValues: values, value,
                error,
                onChange }));
            return renderCell(field, error, !disabled);
        }
        else {
            return React.createElement(exports.DomainCell, Object.assign({}, props));
        }
    });
    function DataList(array, columnName) {
        const columns = [
            {
                Header: columnName.toString(),
                accessor: columnName
            }
        ];
        return (React.createElement(exports.DataTable, { data: array, columns: columns }));
    }
    exports.DataList = DataList;
});
